import {ModelContext} from "context/ModelContext"
import {Model} from "Model"
import {useContext} from "react"

export const useModel = () => {
    const model: Model = useContext(ModelContext)
    return model
}
